import * as model from './models';

import createAxios from '@framework/http';
const axios = createAxios({ keys: 'userInfo.shopId', DEBUG: process.env.KS_ENV !== 'prod' });

/** 专属分销计划  添加推广者 */
export async function addPromoterUsingPOST(params: { addPromoterParam: model.IAddPromoterParam }) {
    const result = await axios.post<model.IMessageListExclusiveDistributorError>(
        `/rest/op/vc/distribution/plan/exclusive/add/promoter`,
        { ...params.addPromoterParam }
    );
    return result;
}

/** 专属分销计划  创建专属分销计划check */
export async function checkCreatePlanUsingPOST(params: { checkCreatePlanParam: model.ICreatePlanCheckParam }) {
    const result = await axios.post<model.IMessageCheckCreatePlanVO>(
        `/rest/op/vc/distribution/plan/exclusive/create/check`,
        { ...params.checkCreatePlanParam }
    );
    return result;
}

/** 专属分销计划  创建专属分销计划 */
export async function createExclusiveV2UsingPOST(params: {
    createExclusiveItemPlanParamV2: model.ICreateExclusiveItemPlanParamV2;
}) {
    const result = await axios.post<model.IMessageCreateExclusivePlanVoV2>(
        `/rest/op/vc/distribution/plan/exclusive/create/v2`,
        { ...params.createExclusiveItemPlanParamV2 }
    );
    return result;
}

/** 专属分销计划  商品分页查询 */
export async function getItemExclusiveUsingPOST(params: { queryItemByPagParam: model.IQueryItemByPagParam }) {
    const result = await axios.post<model.IMessageItemVoList>(`/rest/op/vc/distribution/plan/exclusive/get/item`, {
        ...params.queryItemByPagParam,
    });
    return result;
}

/** 专属分销计划  单独查询计划推广者 */
export async function getPromoterExclusiveUsingPOST(params: { param: model.IGetPromoterParam }) {
    const result = await axios.post<model.IMessageUserVoList>(`/rest/op/vc/distribution/plan/exclusive/get/promoter`, {
        ...params.param,
    });
    return result;
}

/** 专属分销计划  暂停计划 */
export async function invalidateExclusiveUsingPOST(params: { invalidatePlanParam: model.IInvalidatePlanParam }) {
    const result = await axios.post<model.IMessageboolean>(`/rest/op/vc/distribution/plan/exclusive/invalidate`, {
        ...params.invalidatePlanParam,
    });
    return result;
}

/** 专属分销计划  列表查询 */
export async function listExclusiveUsingPOST(params: { param: model.IQueryPlanByPageParam }) {
    const result = await axios.post<model.IMessageExclusivePlanVoList>(`/rest/op/vc/distribution/plan/exclusive/list`, {
        ...params.param,
    });
    return result;
}

/** 专属分销计划  列表查询 */
export async function listExclusiveV2UsingPOST(params: { param: model.IQueryPlanByPageParam }) {
    const result = await axios.post<model.IMessagePlanVoList>(`/rest/op/vc/distribution/plan/exclusive/list/v2`, {
        ...params.param,
    });
    return result;
}

/** 专属分销计划  删除计划 */
export async function removeExclusiveUsingPOST(params: { param: model.IRemovePlanParam }) {
    const result = await axios.post<model.IMessageboolean>(`/rest/op/vc/distribution/plan/exclusive/remove`, {
        ...params.param,
    });
    return result;
}

/** 专属分销计划  删除计划推广者 */
export async function removePromoterExclusiveUsingPOST(params: { param: model.IRemovePromoterParam }) {
    const result = await axios.post<model.IMessageboolean>(`/rest/op/vc/distribution/plan/exclusive/remove/promoter`, {
        ...params.param,
    });
    return result;
}

/** 专属分销计划  恢复计划 */
export async function resumeExclusiveUsingPOST(params: { resumePlanParam: model.IResumePlanParam }) {
    const result = await axios.post<model.IMessageboolean>(`/rest/op/vc/distribution/plan/exclusive/resume`, {
        ...params.resumePlanParam,
    });
    return result;
}

/** 专属分销计划  更新计划佣金比例 */
export async function updateRateUsingPOST(params: { updatePlanRateParam: model.IUpdatePlanRateParam }) {
    const result = await axios.post<model.IMessageboolean>(`/rest/op/vc/distribution/plan/exclusive/updateRate`, {
        ...params.updatePlanRateParam,
    });
    return result;
}
